export const captureDiagnostic = async (message, level, extra) => {
  try {
    const Sentry = await import("@sentry/react");
    Sentry.captureMessage(message, { level, extra });
  } catch (e) {
    // best-effort diagnostic only — never throw from here
  }
};
